import React, { useState } from 'react'
import Plus from '../icons/Plus'
import Modal from './Modal'
import CreateTutorModal from './CreateTutorModal'

type Props = {}

const CreateTutorButton = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer">
        <div className="text-white w-5 h-5">
          <Plus />
        </div>
        <div className="text-14 font-semibold text-white">Add Tutor</div>
      </div>
      <Modal isOpen={isOpen} toggleModal={() => setIsOpen(!isOpen)}>
        <CreateTutorModal toggleModal={() => setIsOpen(!isOpen)} />
      </Modal>
    </>
  )
}

export default CreateTutorButton
